import { IController } from 'angular';
import { size } from 'lodash';

import { ICreditRequirement } from '../../../../../../ng2/shared/constants/credit-requirements.constant';
import { IStudent } from '../../../../../../ng2/shared/typings/interfaces/student.interface';
import { ImStudentCreditGaps } from '../../../../../shared/static-models/im-models/im-student-credit-gaps';

export class StudentCreditGapsPanelProgressCtrl implements IController {
  static $inject: string[] = ['ImStudentCreditGaps'];

  // bindings
  school;
  student;
  sharedState: any; // TODO: add interface

  // class properties
  selectedCreditReq: ICreditRequirement;
  selectedCreditReqHumanShort: string;
  startGapForCreditReq: number;
  neededForOnTrack;
  neededForOnTrackForCreditReq: number;
  gradReqForCreditReq: any;
  earnedPlusScheduledForCreditReq: number;
  earnedForCreditReq: number;
  scheduledForCreditReq: number;
  gradReqsForStudent: any; // object

  constructor(private imStudentCreditGaps: ImStudentCreditGaps) {
    //
  }

  $onInit() {
    const { selectedCreditReq } = this.sharedState;

    this.neededForOnTrack = this.imStudentCreditGaps.getStudentOnTrackMetrics(this.student, this.school);
    this.gradReqsForStudent = this.getGradReqsForStudent(this.student, this.neededForOnTrack);

    this.setValuesForCreditReq(selectedCreditReq);
  }

  $onChanges(changesObj) {
    const { sharedState } = changesObj;
    // needed for changes between v2 and v3 components in ngOnChanges (JE)
    const previousValue = sharedState ? sharedState.previousValue : null;
    const sharedStateChangesObjInitialized = !!size(previousValue);

    if (sharedStateChangesObjInitialized) {
      const { sharedState } = changesObj;
      const { previousValue, currentValue } = sharedState;
      const oldCreditReq = previousValue && previousValue.selectedCreditReq;
      const newCreditReq = currentValue && currentValue.selectedCreditReq;

      if (newCreditReq !== oldCreditReq) {
        this.setValuesForCreditReq(newCreditReq);
      }
    }
  }

  private setValuesForCreditReq(creditRequirement: ICreditRequirement) {
    const { earnedPlusScheduled, earned, scheduled } = this.getStudentCreditDetailsByAreaForCreditReq(
      creditRequirement,
    );

    this.selectedCreditReqHumanShort = creditRequirement.humanShort.toUpperCase();
    this.startGapForCreditReq = this.getStartGapForCreditReq(creditRequirement);
    this.neededForOnTrackForCreditReq = this.getNeededForOnTrackForCreditReq(creditRequirement);
    this.gradReqForCreditReq = this.gradReqsForStudent[creditRequirement.camelCase].gradReq;
    this.earnedPlusScheduledForCreditReq = earnedPlusScheduled;
    this.earnedForCreditReq = earned;
    this.scheduledForCreditReq = scheduled;
  }

  private getGradReqsForStudent(student: IStudent, neededForOnTrack) {
    const gradReqForStudent = this.imStudentCreditGaps.getGradReqsForStudent(student, neededForOnTrack);

    return gradReqForStudent;
  }

  private getStartGapForCreditReq(creditRequirement: ICreditRequirement): number {
    const { camelCase } = creditRequirement;
    const startGapForCreditReq = this.imStudentCreditGaps.getStartGapForGradReq(this.student, camelCase);
    if (startGapForCreditReq > 0) return 0;
    return startGapForCreditReq;
  }

  private getNeededForOnTrackForCreditReq(creditRequirement: ICreditRequirement): number {
    const { camelCase } = creditRequirement;
    const neededCreditReqs = this.neededForOnTrack[camelCase];

    return neededCreditReqs;
  }

  private getStudentCreditDetailsByAreaForCreditReq(creditRequirement: ICreditRequirement) {
    const { camelCase } = creditRequirement;
    const { earnedPlusScheduled, earned, scheduled } = this.student.creditDetails.byArea[camelCase];

    return { earnedPlusScheduled, earned, scheduled };
  }
}
